import React from "react";

type Commend3ModalProps = {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  footer: React.ReactNode;
};

const Commend3Modal = ({ isOpen, title, onClose, children, footer }: Commend3ModalProps) => {
  if (!isOpen) return null;

  return (
    <div
      className="tw-fixed tw-inset-0 tw-z-[200] tw-flex tw-items-center tw-justify-center"
      style={{ background: "rgba(0,0,0,.35)" }}
    >
      <div
        className="tw-flex tw-w-[420px] tw-max-w-[92vw] tw-flex-col tw-overflow-hidden tw-rounded-xl tw-bg-white"
        style={{
          border: "0.5px solid #E3E5EC",
          boxShadow: "0 8px 40px rgba(0,0,0,.18)",
        }}
        role="dialog"
        aria-label={title}
      >
        <div
          className="tw-flex tw-items-center tw-justify-between tw-px-5 tw-pb-3.5 tw-pt-[17px]"
          style={{ borderBottom: "0.5px solid #E3E5EC" }}
        >
          <span className="tw-text-[15px] tw-font-medium">{title}</span>
          <button
            type="button"
            className="tw-h-7 tw-w-7 tw-rounded-md tw-text-[18px] tw-leading-none tw-text-[#59596E]"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div className="tw-px-5 tw-py-[18px]">{children}</div>

        <div
          className="tw-flex tw-justify-end tw-gap-2 tw-px-5 tw-py-[13px]"
          style={{ borderTop: "0.5px solid #E3E5EC" }}
        >
          {footer}
        </div>
      </div>
    </div>
  );
};

export const Commend3ModalLabel = ({ children }: { children: React.ReactNode }) => (
  <span
    className="tw-mb-1.5 tw-block tw-text-[11px] tw-font-medium tw-uppercase tw-text-[#59596E]"
    style={{ letterSpacing: ".05em" }}
  >
    {children}
  </span>
);

export const Commend3ModalInput = ({
  value,
  placeholder,
  invalid,
  disabled,
  onChange,
  id,
}: {
  value: string;
  placeholder?: string;
  invalid?: boolean;
  disabled?: boolean;
  onChange: (next: string) => void;
  id: string;
}) => (
  <input
    id={id}
    type="text"
    value={value}
    placeholder={placeholder}
    disabled={disabled}
    onChange={(event) => onChange(event.target.value)}
    className="tw-w-full tw-rounded-lg tw-bg-white tw-px-[11px] tw-py-2 tw-text-[13px]"
    style={{
      border: `0.5px solid ${invalid ? "#DC2626" : "#E3E5EC"}`,
      color: "#030562",
    }}
  />
);

export const Commend3SecondaryButton = ({
  children,
  onClick,
  disabled,
  id,
}: {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  id: string;
}) => (
  <button
    id={id}
    type="button"
    className="tw-inline-flex tw-items-center tw-rounded-md tw-bg-white tw-px-3.5 tw-py-[7px] tw-text-[13px] tw-font-medium tw-text-[#0B0C23]"
    style={{
      border: "0.5px solid #E3E5EC",
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.5 : 1,
    }}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);

export const Commend3PrimaryButton = ({
  children,
  onClick,
  disabled,
  danger,
  id,
}: {
  children: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  danger?: boolean;
  id: string;
}) => (
  <button
    id={id}
    type="button"
    className="tw-inline-flex tw-items-center tw-rounded-md tw-px-3.5 tw-py-[7px] tw-text-[13px] tw-font-medium tw-text-white"
    style={{
      border: "0.5px solid transparent",
      background: danger ? "#D60027" : "#030562",
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.5 : 1,
    }}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);

export default Commend3Modal;
